<template>
  <b-container fluid="xl" class="header-nav">
    <router-link to="/">
      <img class="logo" src="../assets/logo-mobile.png" alt="logo" />
    </router-link>

    <MenuIcon class="menu-icon" v-model="isOpened" />

    <b-sidebar
      v-model="isOpened"
      right
      shadow
      width="50%"
      sidebar-class="mobile-nav-wrap"
    >
      <MenuIcon slot="header-close" :value="true" class="close-item" />
      <ul>
        <li v-for="item in menus" :key="item.name">
          <router-link
            :to="item.path"
            active-class="active-menu"
            class="nav-item-label"
          >
            <span v-t="item.name"></span>
          </router-link>
          <ul
            v-if="item.children && item.children.length > 0"
            style="padding-top: 0"
          >
            <li v-for="subMenu in item.children" :key="subMenu.name">
              <router-link
                :to="subMenu.path"
                active-class="active-menu"
                class="nav-item-label"
              >
                <span v-t="subMenu.name"></span>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="lang-selector">
          <span
            v-for="(item, index) in langList"
            :key="index"
            @click="onLangSelected(index)"
          >
            {{ item.label }}
          </span>
        </li>
      </ul>
    </b-sidebar>
  </b-container>
</template>

<script>
import menus from './menus'
import MenuIcon from './MenuIcon'
export default {
  name: 'NavBar-mobile',
  components: {
    MenuIcon
  },
  data() {
    return {
      isOpened: false,
      activeLang: 0,
      langList: [
        {
          label: 'ENG',
          value: 'en-US'
        },
        {
          label: '简',
          value: 'zh-CN'
        },
        {
          label: '繁',
          value: 'zh-CN-HK'
        }
      ],
      menus
    }
  },
  methods: {
    onLangSelected(index) {
      this.activeLang = index
      this.$i18n.locale = this.langList[index].value
    }
  }
}
</script>

<style lang="scss">
.lang-selector {
  margin-left: -10px;
  span {
    color: #ffffff;
    padding: 10px;

    & ~ span {
      position: relative;

      &:after {
        content: '';
        width: 1px;
        background-color: #ffffff;
        height: 10px;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }
    }
  }
}

.mobile-nav-wrap {
  background: linear-gradient(165deg, #6c63ff 60%, #c77cf1);

  .nav-item-label {
    color: #ffffff;
  }
  .active-menu {
    text-decoration: underline;
  }
}

.close {
  opacity: 1 !important;
  outline: none !important;
}
.close-item {
  margin-top: 10px;
}
</style>
<style scoped lang="scss">
.header-nav {
  .logo {
    width: 105px;
  }

  .menu-icon {
    float: right;
  }
}
.mobile-nav-wrap {
  ul {
    padding: 20px 0 0 30px;
    text-align: left;

    li {
      list-style: none;

      > a > span {
        line-height: 40px;
      }
    }
  }
}

ul.lang-list {
  padding: 0;
  margin: 0;

  li {
    list-style: none;
    line-height: 35px;
    width: 80px;
    text-align: center;
    cursor: pointer;

    &:hover,
    &.active {
      background-color: #eeeeee;
    }

    & + li {
      border-top: 1px solid #eeeeee;
    }
  }
}
</style>
